import React from 'react';
import { string, func } from 'prop-types';

import { noop } from '@ajaibid/utils';
import Button from '../Button'; // Change to ButtonV2
import Typography from '../Typography';

import { styAlignRight } from './style';

const Content = (props) => {
  const { title, description, actionText, onClick } = props;
  return (
    <div>
      {title && (
        <Typography type="body" size="lg" bold style={{ marginTop: '0px', marginBottom: '12px' }}>
          {title}
        </Typography>
      )}
      {description && (
        <Typography type="body" style={{ marginTop: '0px', marginBottom: '6px' }}>
          {description}
        </Typography>
      )}
      <div className={styAlignRight}>
        <Button variant="primary" size="sm" style={{ minWidth: 0 }} onClick={onClick}>
          {actionText}
        </Button>
      </div>
    </div>
  );
};

Content.propTypes = {
  title: string,
  description: string,
  actionText: string,
  onClick: func,
};

Content.defaultProps = {
  title: '',
  description: '',
  actionText: 'OK',
  onClick: noop,
};

export default Content;
